import { Box, Typography } from "@mui/material";

export default function InviteSummary(){
  return (
    <Box>
      <Typography variant="body1">
        Compartilhe o acesso com nossa equipe para que possamos configurar e cuidar da publicação do seu aplicativo.
      </Typography>
    </Box>
  )
}